interface FeatureCheck {
    test: () => boolean;       // Returns true if feature exists
    polyfill: () => Promise<any>; // Dynamic import for missing feature
}

// List all features that may require polyfills
const featureChecks: FeatureCheck[] = [
    {
        test: () => typeof Array.prototype.toSpliced === 'function',
        polyfill: () => import("core-js/features/array/to-spliced")
    },
    {
        test: () => typeof Array.prototype.toSorted === 'function',
        polyfill: () => import("core-js/features/array/to-sorted")
    },
    {
        test: () => typeof Array.prototype.toReversed === 'function',
        polyfill: () => import("core-js/features/array/to-reversed")
    },
    {
        test: () => typeof Array.prototype.with === 'function',
        polyfill: () => import("core-js/features/array/with")
    }
];

export async function loadPolyfills() {
    // Dynamically load only missing features
    const imports: Promise<any>[] = featureChecks
        .filter((f: FeatureCheck) => !f.test())
        .map((f: FeatureCheck) => f.polyfill());
    if (imports.length > 0) {
        await Promise.all(imports);
    }
}
